<template>
    <option value="US">US</option>
    <option value="CA">CA</option>
    <option value="AU">AU</option>
    <option value="IQ">IQ</option>
</template>
